import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 py-12 text-center', className)}>
      {icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-outlines text-text-secondary">
          {icon}
        </div>
      )}
      <h3 className="text-[15px] font-semibold text-text-primary">{title}</h3>
      {description && <p className="max-w-xs text-sm text-text-placeholder">{description}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
